import {
    AmountSeries,
    SupplierSeries,
    SuppliersSpendVolumeResponse
} from '@lsq-frontend/remote-services/analytics-graphql/src/lib/utils/types';
import { ChartFilters, TopSuppliersType } from './chart-types';
import chartUtils, { mapCentsToDollars, spendVolumeSort } from './chart-utils';
import { HighChartComponent } from '../lsq-high-charts';

const getTopSuppliersConfig = (data: TopSuppliersType) => {
    const abbrevi = chartUtils.getDataLabelAbbreviator();
    let colors = chartUtils.elevenColors.slice(0, 10);
    const diff = data.data.length - colors.length;
    if (diff > 0) {
        colors = colors.concat(Array.from(Array(diff), (_) => chartUtils.elevenColors[10]));
    }
    const chartConfig = {
        chart: {
            type: 'column',
            inverted: true,
            height: '450px',
            scrollablePlotArea: {
                minHeight: 700
            }
        },
        title: {
            text: null,
            align: 'left'
        },
        xAxis: {
            categories: data.categories,
            title: {
                text: null
            },
            labels: {
                style: chartUtils.getTextStyle()
            },
            min: 0
        },
        yAxis: {
            min: 0,
            title: {
                text: 'AP Spend ($)',
                style: chartUtils.getTextStyle()
            },
            labels: {
                style: chartUtils.getTextStyle()
            }
        },
        tooltip: {
            style: chartUtils.getTextStyle(),
            formatter: function (this: any) {
                const body = 'AP Spend: <b>' + chartUtils.abbreviatorFormatter(this.y) + '</b>';
                return '<div>' + this.x + '</br>' + body + '</div>';
            }
        },
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: true
                },
                colorByPoint: true
            },
            series: {
                groupPadding: 0,
                pointPadding: 0.1,
                borderWidth: 0
            }
        },
        exporting: {
            enabled: false
        },
        colors: colors,
        series: [
            {
                name: 'Total',
                data: data.data.map(mapCentsToDollars),
                showInLegend: false,
                ...abbrevi
            }
        ]
    };
    return chartConfig;
};

export default getTopSuppliersConfig;

export const GetTopSuppliersSchema = (
    data: SuppliersSpendVolumeResponse,
    filters: ChartFilters,
    context: HighChartComponent
) => {
    if (data.suppliers.length === 0) {
        throw new Error('Empty data');
    }
    const sourceData = data.suppliers.sort(spendVolumeSort);
    const suppliersData = sourceData.map((supp: SupplierSeries) => ({
        name: supp.name,
        total: supp.amountSeries.reduce(
            (total: number, serie: AmountSeries) => total + serie.invoiceAmount.cents,
            0
        )
    }));

    const suppliers = data.suppliers.map((supp: SupplierSeries) => supp.name).sort();
    if (!context.suppliers) {
        context.suppliers = suppliers;
    }

    const schema = getTopSuppliersConfig({
        data: suppliersData.map((supp) => supp.total),
        categories: suppliersData.map((supp) => supp.name)
    });
    return schema;
};
